import { formatCurrencyValues } from "../../utils/convertUtils";

const mapCard = (json) => {
    const {
        AccountID,
        SumBalDebit,
        SumBalCredit,
        SumBalDebitN1,
        SumBalCreditN1,
        SumBalDebitN2,
        SumBalCreditN2,
        SumBalDebitN3,
        SumBalCreditN3,
        CurrencyOptions,
    } = json;

    return [
        [{ labels: ["Account ID"], value: AccountID, type: "string" }],
        [
            {
                labels: ["SumBalDebit"],
                value: formatCurrencyValues(CurrencyOptions, SumBalDebit),
                type: "currency",
            },
        ],
        [
            {
                labels: ["SumBalCredit"],
                value: formatCurrencyValues(CurrencyOptions, SumBalCredit),
                type: "currency",
            },
        ],
        [
            {
                labels: ["SumBalDebitN1"],
                value: formatCurrencyValues(CurrencyOptions, SumBalDebitN1),
                type: "currency",
            },
        ],
        [
            {
                labels: ["SumBalCreditN1"],
                value: formatCurrencyValues(CurrencyOptions, SumBalCreditN1),
                type: "currency",
            },
        ],
        [
            {
                labels: ["SumBalDebitN2"],
                value: formatCurrencyValues(CurrencyOptions, SumBalDebitN2),
                type: "currency",
            },
        ],
        [
            {
                labels: ["SumBalCreditN2"],
                value: formatCurrencyValues(CurrencyOptions, SumBalCreditN2),
                type: "currency",
            },
        ],
        [
            {
                labels: ["SumBalDebitN3"],
                value: formatCurrencyValues(CurrencyOptions, SumBalDebitN3),
                type: "currency",
            },
        ],
        [
            {
                labels: ["SumBalCreditN3"],
                value: formatCurrencyValues(CurrencyOptions, SumBalCreditN3),
                type: "currency",
            },
        ],
    ];
};

const header = [
    { label: ["Account Id"], align: "left", basis: "25%" },
    { label: ["Current - Debit"], align: "right", basis: "10%" },
    { label: ["Current - Credit"], align: "right", basis: "10%" },
    { label: ["N-1 Debit"], align: "right", basis: "10%" },
    { label: ["N-1 Credit"], align: "right", basis: "10%" },
    { label: ["N-2 Debit"], align: "right", basis: "10%" },
    { label: ["N-2 Credit"], align: "right", basis: "10%" },
    { label: ["N-3 Debit"], align: "right", basis: "10%" },
    { label: ["N-3 Credit"], align: "right", basis: "10%" },
];

const mapper = (json, card) => {
    return {
        ...json,
        name: json.name,
        shortName: json.name,
        card: card ? mapCard(json) : [],
        link: {
            to: "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix/reports/nc_statement_accounts_accumulated",
            filter: [
                { filters: [{ value: json.AccountID }], column: "AccountID" },
                {
                    filters: [{ value: `0#${json.MaxPeriod}` }],
                    column: "Period",
                    operator: "between",
                },
            ],
        },
    };
};

const nctrialbalancepluriannualMapper = {
    map: mapper,
    header,
};

export default nctrialbalancepluriannualMapper;
